import React from 'react';
import { Stack, Fade, Box } from '@mui/material';
import { CalendarEvent } from '../types/event';
import EventCard from './EventCard';

interface EventListProps {
    events: CalendarEvent[];
}

const EventList = ({ events }: EventListProps) => {
    return (
        <Stack spacing={4}>
            {events.map((event, index) => (
                <Fade
                    key={event.announcementId}
                    in={true}
                    timeout={500 + index * 100}
                    style={{ transitionDelay: `${index * 50}ms` }}
                >
                    <Box sx={{ width: '100%' }}>
                        <EventCard event={event} index={index} />
                    </Box>
                </Fade>
            ))}
        </Stack>
    );
};

export default EventList;
